import _createClass from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// Extensions
import { Service } from '../service'; // Utilities

import { mergeDeep } from '../../util/helpers'; // Presets

import presets from './presets';
export var Icons = /*#__PURE__*/function (_Service) {
  _inherits(Icons, _Service);
  var _super = _createSuper(Icons);
  function Icons(preset) {
    var _this;
    _classCallCheck(this, Icons);
    _this = _super.call(this);
    var _preset$Icons$propert = preset[Icons.property],
      iconfont = _preset$Icons$propert.iconfont,
      values = _preset$Icons$propert.values,
      component = _preset$Icons$propert.component;
    _this.component = component;
    _this.iconfont = iconfont;
    _this.values = mergeDeep(presets[iconfont], values);
    return _this;
  }
  return _createClass(Icons);
}(Service);
Icons.property = 'icons';